import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useParams } from "react-router-dom";
import { BiCopy } from "react-icons/bi";

const NewApi = ({ show, handleClose, fetchRecords }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const [copiedSecret, setCopiedSecret] = useState(false);
    const [copiedPublic, setCopiedPublic] = useState(false);
    const [secretKey, setSecretKey] = useState(null);
    const [publicKey, setPublic] = useState(null);
    const [apiName, setApiName] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState({ message: "", display: false })

    useEffect(() => {
        if (show) {
            CheckAPI()
        }
    }, [show]);

    const handleCopyClick = () => {
        navigator.clipboard.writeText(secretKey);
        setCopiedSecret(true);
        setTimeout(() => setCopiedSecret(false), 2000);
    };


    const handleCopyClickPublic = () => {
        navigator.clipboard.writeText(publicKey);
        setCopiedPublic(true);
        setTimeout(() => setCopiedPublic(false), 2000);
    };

    const CheckAPI = async () => {
        setSecretKey(null)
        setError({ message: "", display: false })
        setLoading(true)
        try {
            const response = await fetch('https://backend.erioon.com/check_api', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setLoading(false)
            if (response.ok) {
                const result = await response.json();
                const secret = result.api_key
                const public_key = result.pub_key
                setSecretKey(secret)
                setPublic(public_key)
            } else {
                setError({ message: t.err_page, display: true })
            }
        } catch (error) {
            setLoading(false)
            setError({ message: t.err_page, display: true })
        }
    }

    const GenerateAPI = async () => {
        setLoading(true)
        setError({ message: "", display: false })

        if (secretKey != null) {

            let dataToSend = {
                user_id: user_id,
                key: secretKey,
                name: apiName,
                public_key: publicKey
            }
            try {
                const response = await fetch('https://backend.erioon.com/gen_api', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataToSend),
                });
                setLoading(false)
                if (response.ok) {
                    CloseModal()
                    fetchRecords()
                } else {
                    setError({ message: t.err_save_general, display: true })
                }
            } catch (error) {
                setLoading(false)
                setError({ message: t.err_save_general, display: true })
            }
        }

    }

    const CloseModal = () => {
        setApiName(null)
        setSecretKey(null)
        handleClose()
        setError({ message: "", display: false })
    }

    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label">{t.apis.title}</p>
                <p className="share_label_desc">
                    API keys are tied to your profile rather than individual projects, allowing them to access all projects and resources under your account.
                </p>
                <div className="warning_delete_message">
                    {/* <p>{t.apis.warning} <span onClick={() => window.open("/docs/errors-and-bugs", "_blank")}>{t.docu_link}</span>.</p> */}
                    <p><strong><i className="fa-solid fa-warning"></i> {t.apis.keep_secret_mex}</strong></p>
                </div>
                <input
                    className="api_name_input"
                    placeholder={t.apis.name}
                    value={apiName}
                    onChange={(e) => setApiName(e.target.value)}
                ></input>
                {/* <p className="link_cont_file_share_desc">
                    Kept secret. Provides full access to read, write, update, and delete data via the SDK and CLI.
                </p> */}
                <div className="link_cont_file_share">
                    <div className="link_file">
                        <p>
                            {secretKey ? (
                                <span>{secretKey}</span>
                            ) : (
                                <div className="loading_link_container"></div>
                            )}
                        </p>
                    </div>
                    <button className="copy_clipboard_link_file_btn" onClick={handleCopyClick}>
                        {copiedSecret ? <i className="fa-solid fa-check"></i> : <BiCopy />}
                    </button>
                </div>
                {/* <p className="link_cont_file_share_desc">
                    Used in client apps for safe, write-only access (e.g., inserts). Cannot read or modify existing data.
                </p>
                <div className="link_cont_file_share">
                    <div className="link_file">
                        <p>
                            {publicKey ? (
                                <span>{publicKey}</span>
                            ) : (
                                <div className="loading_link_container"></div>
                            )}
                        </p>
                    </div>
                    <button className="copy_clipboard_link_file_btn" onClick={handleCopyClickPublic}>
                        {copiedPublic ? <i className="fa-solid fa-check"></i> : <BiCopy />}
                    </button>
                </div> */}
            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={GenerateAPI}
                        disabled={apiName === null || apiName.trim() === "" || secretKey == null}
                    >
                        {loading ? (
                            <Spinner loading={loading} />
                        ) : (
                            <>
                                {t.save} API
                            </>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>

            </div>
        </Modal>
    );
};

export default NewApi;
